import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Chat from "./pages/Chat";
import Error from "./pages/Error";
import Home from "./pages/Home";
import { AppContainer, PageContainer } from "./shared/layout";

function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="app-root">
            <Header mainTitle={"ChatBot"} />
            <AppContainer>
              <PageContainer>
                <Home />
              </PageContainer>
            </AppContainer>
          </div>
        }
      />
      {/* /chat 使用纯净全屏 100vw x 100vh 超级工作区 */}
      <Route path="/chat/:token_id" element={<Chat />} />
      <Route
        path="*"
        element={
          <div className="app-root">
            <Header mainTitle={"ChatBot"} />
            <AppContainer>
              <PageContainer>
                <Error />
              </PageContainer>
            </AppContainer>
          </div>
        }
      />
    </Routes>
  );
}

export default App;
